import { observer } from 'mobx-react';
import { autoinject, bind, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AccountStore } from './AccountStore';

export interface ILoginCallbackProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class LoginCallbackView extends React.Component<ILoginCallbackProps> {
    public async componentDidMount() {
        const state = await this.accountStore.signinRedirectCallback();
        this.redirect(state);
    }

    public render() {
        return (
            <div>
                <div>Logging in...</div>
                <br />
                <div>
                    <p>If you see this page for an extended amount of time (More than 5 sec).</p>

                    <ul>
                        <li>Make sure your clock is correct on your current device.</li>

                        <li>
                            <a className="btn btn-link px-0" onClick={this.goToLogin}>
                                Click Here
                            </a>{' '}
                            to return to the login page.
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    @bind
    private redirect(state: any) {
        if (state == 'error') return;
        const internalUrl = (window as any).initialInternalUrl as string;
        const isPortalLiteUser = this.accountStore.isInRoles(['PortalLiteUser']);
        const isPortalUser = this.accountStore.isInRoles([
            'MriAdmin',
            'PortalAdmin',
            'MriUser',
            'PortalUser',
            'PortalLiteUser',
        ]);
        const isProdUser = this.accountStore.isInRoles(['ProdTestUser', 'ProdUser']);
        const returnUrl: string = state?.returnUrl ?? '/';

        if (isPortalLiteUser) {
            this.props.history.push('/warranty-alerts');
        } else if (!isPortalUser && isProdUser) {
            window.location.replace(internalUrl);
        } else if (returnUrl.startsWith('/')) {
            this.props.history.push(returnUrl);
        } else {
            throw new Error('Invalid return URL');
        }
    }

    @bind
    private goToLogin() {
        window.location.replace('login');
    }
    @inject
    private accountStore!: AccountStore;
}
